import React from 'react';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Intro } from '../components/Intro';
import { DifficultSituation } from '../components/DifficultSituation';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { Trajectory } from '../components/Trajectory';
import { MaestroJohn } from '../components/MaestroJohn';
import { LoveGuidance } from '../components/LoveGuidance';
import { FinalCTA } from '../components/FinalCTA';
import { Contact } from '../components/Contact';
import { Policies } from '../components/Policies';
import { Footer } from '../components/Footer';
import { MobileActionBar } from '../components/MobileActionBar';
import { useTawkTo } from '../hooks/useTawkTo';
import { useViewportMeta } from '../hooks/useViewportMeta';
interface LandingProps {
  lockup: string;
  showTestimonials: boolean;
  showConsultationCount: boolean;
  freeInitialConsultation: boolean;
}
export function Landing({
  lockup,
  showTestimonials,
  showConsultationCount,
  freeInitialConsultation
}: LandingProps) {
  useViewportMeta();
  useTawkTo();
  return <div className="min-h-full w-full bg-carbon font-sans" data-id="element-210" data-mp="3tifv72l2ri7b">
      <Header lockup={lockup} data-id="element-211" data-mp="3pfrmcuwd2bac" />
      <main data-id="element-212" data-mp="3pgua4tydzxm1">
        <MobileActionBar data-id="element-213" data-mp="3pgksbtnhwwrf" />
        <Hero lockup={lockup} data-id="element-214" data-mp="3kg6j48a5rgrt" />
        <Intro data-id="element-215" data-mp="3kgydxgvxlah1" />
        <DifficultSituation data-id="element-216" data-mp="3khhmw83lsoix" />
        <Services data-id="element-217" data-mp="l0i8u09aaxnc" />
        <LoveGuidance data-id="element-218" data-mp="l11lb1g60ttz" />
        {showTestimonials ? <Testimonials data-id="element-219" data-mp="kzqeesrfb5yn" /> : null}
        <Trajectory showConsultationCount={showConsultationCount} data-id="element-220" data-mp="gywojtuf7h34" />
        <MaestroJohn data-id="element-221" data-mp="gzpzl70ewsr2" />
        <FinalCTA freeInitialConsultation={freeInitialConsultation} data-id="element-222" data-mp="h1amqbked9ew" />
        <Contact data-id="element-223" data-mp="c6ddp4n4b020" />
        <Policies data-id="element-224" data-mp="c5v8hiih9bhy" />
      </main>
      <Footer lockup={lockup} data-id="element-225" data-mp="79myejj508hn" />
    </div>;
}